import React from 'react';
import { faAngleLeft, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import '../../style/scss/detailpage.scss';

export interface LibraryCard {
    type: string;
    icon: IconDefinition;
    title: string;
    description: string;
    requiredFeature?: string;
}

export interface LibraryCards {
    groupHeader?: string;
    requiredFeature?: string;
    cards: LibraryCard[];
}

interface LibraryPageProps {
    headerTitle: string;
    libraryCards: LibraryCards[];
    selected?: LibraryCard | null;
    backButtonUrl?: string;
    setSelected?: (card: LibraryCard) => void;
    onSubmit: (card: LibraryCard) => void;
}

const LibraryPage: React.FC<LibraryPageProps> = ({ 
    headerTitle, libraryCards, selected, backButtonUrl, setSelected, onSubmit
}) => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <div className='detailpage library-page container-filled'>
            <div className='detailpage-header row'>
                <div className='header-title'>
                    <span className='back-button'
                          onClick={() => {
                                if (backButtonUrl) {
                                    history.push(backButtonUrl);
                                } else {
                                    history.goBack();
                                }
                            }}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </span>
                    <h2 className='fixed-title'>
                        {t(headerTitle)}
                    </h2>
                </div>
            </div>
            <div className='' style={{ marginTop: '2.5rem' }}>
                {libraryCards.map((group, index) => 
                    <div className='library-group' key={index}>
                        {group.groupHeader && (
                            <h4>{t(group.groupHeader)}</h4>
                        )}
                        <div className='library-cards'>
                            {group.cards.map((card, cardIndex) => {
                                return (
                                    <div 
                                        key={cardIndex}
                                        onClick={() => {
                                            setSelected?.(card);
                                            onSubmit?.(card);
                                        }}
                                        className={`library-card ${selected?.type === card.type ? 'selected' : ''} `}
                                    >
                                        <div className='icon'>
                                            <FontAwesomeIcon icon={card.icon} />
                                        </div>
                                        <div className='title'>
                                            <h5>{t(card.title)}</h5>
                                        </div>
                                        <div className='description'>
                                            <p>{t(card.description)}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
};

export default LibraryPage;